/* eslint-disable max-lines */
/* eslint-disable @typescript-eslint/no-explicit-any */

import { call, put, select, takeEvery } from "redux-saga/effects";

import { getIsUserSignedIn } from "@gamedev-web/gamedev-sdk-core";

import { PageType, siteLocationPrefix } from "../../constants";
import { OnboardingErrorType } from "../../models/errors";
import { CapabilitiesActions, capabilitiesActions } from "../actions/capabilitiesActions";
import { statusActions } from "../actions/statusActions";
import { CapabilitiesState } from "../reducers/capabilitiesReducer";
import { storeError } from "./dataStorage/storeError";

const updateCapabilitiesUrl = `${siteLocationPrefix}/forms/capabilities`;

export function* capabilitiesStart(
  _action: ReturnType<typeof capabilitiesActions.updateCapabilities.start>
) {
  const isSigned: boolean | undefined = yield select(getIsUserSignedIn);
  if (!isSigned) {
    return;
  }
  try {
    const response: Response = yield call(fetch, updateCapabilitiesUrl);
    const data: CapabilitiesState = yield call([response, "json"]);
    if (response?.status === 200 && data) {
      yield put(capabilitiesActions.updateCapabilities.success(data));
      yield put(statusActions.initialCrmFetchCompleted(PageType.ProgramSelection));
    }
  } catch (e) {
    yield storeError(e, OnboardingErrorType.Save);
  }
}

export function* capabilitiesSagas() {
  yield takeEvery(CapabilitiesActions.UPDATE_CAPABILITIES_START, capabilitiesStart);
}
